var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('Carousel',{attrs:{"items":_vm.details.photos,"height":"100vh"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }